import getFilterWithCol from '../../helpers/getFilterWithCol';

// export const filterSearch = ['FilterField', {
//   id: 'search',
//   label: null, // 'ID',
//   section: 'top',
//   col: 12,
//   buildQuery: (value, builder) => value && builder.add(
//     'where',
//     { name: { REGEX: value, OPTIONS: 'i' } },
//   ),
//   getValueForField: value => value || '',
//   getValueForQuery: (value) => {
//     value = !value
//     ? undefined
//     : value.target
//     ? value.target.value
//     : value;
//     return !value || !value.length
//     ? undefined
//     : value;
//   },
//   field: ['FieldText', {
//     name: 'search',
//     placeholder: 'Search by name',
//   }],
// }];

export const filterSort = ['FilterHidden', {
  id: 'sort',
  build: builder => builder.add('sort', { createdAt: -1 }),
}];

export const filterPopulate = ['FilterHidden', {
  id: 'populate',
  build: builder => builder.add('populate', {
    company: {
      _id: true,
      name: true,
    },
    store: {
      _id: true,
      name: true,
    },
    createdBy: {
      _id: true,
      name: true,
    },
  }),
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const ADMIN = [
  ...[
    // [filterSearch, 12],
  ].map(([filter, col]) => getFilterWithCol(filter, col)),

  filterSort,
  filterPopulate,
  filterPagination,
];
